import classnames from 'classnames';
import React from 'react';
import styles from './count.module.scss';

interface CountProps {
  className?: string;
  value: number;
  id?: string;
}

const Count = ({ value, className, id }: CountProps) => {
  if (!value) {
    return null;
  }
  return (
    <span
      data-testid={id}
      aria-label="counter"
      className={classnames(styles.counter, className)}
    >
      {value}
    </span>
  );
};

export default Count;
